const DOCUMENT_UPLOAD_GROUPS = new Set(["data-uploaders"]);

export const canUploadDocuments = (groups: string[] | undefined | null): boolean =>
    !!groups?.some((group) => DOCUMENT_UPLOAD_GROUPS.has(group));
